import React, {Component  } from 'react';
import { connect } from "react-redux";
import * as vars from './Vars';
import Loader from './loader/ProductLoader';
import * as axios from "axios/index";

import Footer from "./div/Footer";
import ProductSection from "./section/ProductCategoryV3";

import { Modal } from 'react-bootstrap';
import { Swiper , Thumbs , History , HashNavigation } from 'swiper';

import timerIcon from './../assets/images/icons/timer.svg';
import shoppingBagIcon from './../assets/images/icons/shopping-bag.svg';
import backIcon from './../assets/images/icons/back.svg';
import searchIcon from './../assets/images/icons/search.svg';
import deliveryIcon from './../assets/images/icons/delivery.svg';
import arrowBottomIcon from './../assets/images/icons/arrow-bottom.svg';
import {removeFromUserCart , removeFromCart} from "../../actions";
import {Link} from "react-router-dom";
import NumberFormat from 'react-number-format';
import ProductCard from "./section/ProductCard";

Swiper.use([Thumbs , History , HashNavigation ]);
class ProductV4 extends Component{

    constructor(props){

        super(props)

        //this.searchSubmitHandler = this.searchSubmitHandler.bind(this);
        this.state = {
            requestLoading : false ,
            categories : [] ,
            //currentCategory : null,
            branchSlug : "" ,
            branch : [] ,
            currentCategorySlideIndex : null,

            categorySlier : null ,
            productSlier : null ,
            dateSlier : null ,

            preOrderDeliveryDates : [] ,
            deliveryAvailableTimes : [] ,

            preOrderShowModal : false ,
            needPreOrderShowModal : false ,


            orderDeliveryDateTitle : localStorage.getItem( "orderDeliveryDateTitle" )  ,
            orderDeliveryDateValue : localStorage.getItem( "orderDeliveryDateValue" ) ,

            orderDeliveryTimeTime : localStorage.getItem( "orderDeliveryTimeTime" ) ,

            cartLinkShow : false ,
            cartSumPrice : 0 ,

            orderInPreOrder : false ,

            searchShowModal : false,
            errors : {} ,
            fields : {
                search : "" ,
            } ,
            searchHasMore : true ,
            searchPage : 1 ,
            searchProducts : [] ,
            searchRequestLoading : false,

            showPreorderAlertForFirstTime: false,

        }

    }

    cartHandler(){
        /*let totalPrice = 0
        this.setState({
            cartLinkShow : false,
            cartSumPrice : 0 ,
        })

        this.props.cart.map((value , index) => {
            totalPrice += value * this.props.products[index].priceWithDiscount
        })

        if (totalPrice > 0 && this.state.orderDeliveryDateTitle !== null && this.state.orderDeliveryDateValue !== null && this.state.orderDeliveryTimeTime !== null)
        {
            this.setState({
                cartLinkShow : true,
                cartSumPrice : totalPrice ,
            })
        }*/

        let totalPrice = 0;
        Object.keys(this.props.cart).forEach(productId => {
            const qty = this.props.cart[productId];
            const product = this.props.products[productId];
            totalPrice += qty * product.priceWithDiscount;
        });

        const showCart = totalPrice > 0 &&
            this.state.orderDeliveryDateTitle !== null &&
            this.state.orderDeliveryDateValue !== null &&
            this.state.orderDeliveryTimeTime !== null;

        this.setState({
            cartLinkShow: showCart,
            cartSumPrice: totalPrice
        });

    }

    clearCartHandler(){

       /* console.log(this.props.cart)
        this.props.cart.map((value , index) => {
            for (let i=1 ; i<= value ; i++)
            {
                this.props.removeFromUserCart(index)
                this.props.removeFromCart(index)
            }
        })*/
        Object.entries(this.props.cart).forEach(([productId, qty]) => {
            for (let i = 0; i < qty; i++) {
                this.props.removeFromUserCart(productId)
                this.props.removeFromCart(productId)
            }
        });

        this.cartHandler()
    }

    orderDeliveryDateHandler(event){

        this.clearCartHandler()



        this.state.preOrderDeliveryDates.map((preOrderDeliveryDate , index) => {
            if (event.target.getAttribute("data-value") === preOrderDeliveryDate.value)
            {
                //console.log(preOrderDeliveryDate.timing)
                this.setState({
                    "deliveryAvailableTimes" : preOrderDeliveryDate.timing ,
                    "orderDeliveryTimeTime" : "",
                })

                localStorage.removeItem("orderDeliveryTimePreview")
                localStorage.removeItem("orderDeliveryTimeTime")
                localStorage.removeItem("orderDeliveryTimeTitle")
                localStorage.removeItem("orderDeliveryTimeKey")
                localStorage.removeItem("orderDeliveryTimeSelectedByUser")

                setTimeout(
                    function() {

                        let timeSlier = new Swiper('#time-slider', {
                            slidesPerView: 'auto',
                            spaceBetween: 10,

                        })
                        timeSlier.update()
                    }
                        .bind(this),
                    100
                )


                if (preOrderDeliveryDate.isToday === true )
                {
                    this.setState({
                        orderDeliveryDateTitle : "امروز" ,
                        orderDeliveryDateValue : preOrderDeliveryDate.value ,
                        orderInPreOrder : false ,
                    })

                    localStorage.setItem( "orderDeliveryDateTitle" ,  "امروز")
                    localStorage.setItem( "orderDeliveryDateValue" ,  preOrderDeliveryDate.value )
                    localStorage.setItem( "orderDeliveryDateIsToday" ,  true )
                    localStorage.setItem( "orderInPreOrder" ,  false )


                    this.state.deliveryAvailableTimes.map((deliveryAvailableTime , index) => {
                        if (localStorage.getItem("orderDeliveryTimeTime") === deliveryAvailableTime.time)
                        {
                            if (deliveryAvailableTime.current === true)
                            {
                                localStorage.setItem("orderDeliveryTimeSelectedByUser" , false)
                            }
                            else
                            {
                                localStorage.setItem("orderDeliveryTimeSelectedByUser" , true)
                            }
                        }
                    })

                }
                else
                {
                    this.setState({
                        orderDeliveryDateTitle : preOrderDeliveryDate.title ,
                        orderDeliveryDateValue : preOrderDeliveryDate.value ,
                        orderInPreOrder : true ,
                    })

                    localStorage.setItem( "orderDeliveryDateTitle" ,  preOrderDeliveryDate.title)
                    localStorage.setItem( "orderDeliveryDateValue" ,  preOrderDeliveryDate.value )
                    localStorage.setItem( "orderDeliveryDateIsToday" ,  false )
                    localStorage.setItem("orderDeliveryTimeSelectedByUser" , true)
                    localStorage.setItem("orderInPreOrder" , true)
                }




            }
        })
    }


    orderDeliveryTimeHandler(event){

        this.clearCartHandler()

        this.state.deliveryAvailableTimes.map((deliveryAvailableTime , index) => {

            if (
                (
                    event.target.getAttribute("data-time") === deliveryAvailableTime.time &&
                    deliveryAvailableTime.available === true
                )
                ||
                (
                    event.target.getAttribute("data-time") === deliveryAvailableTime.time &&
                    this.state.orderInPreOrder === true &&
                    deliveryAvailableTime.preview === true
                )
            )
            {
                this.setState({
                    orderDeliveryTimeTime : deliveryAvailableTime.time
                })
                localStorage.setItem( "orderDeliveryTimePreview" ,  deliveryAvailableTime.preview)
                localStorage.setItem( "orderDeliveryTimeTime" ,  deliveryAvailableTime.time)
                localStorage.setItem( "orderDeliveryTimeTitle" ,  deliveryAvailableTime.title)
                localStorage.setItem( "orderDeliveryTimeKey" ,  deliveryAvailableTime.key)

                if (deliveryAvailableTime.current === true && this.state.orderInPreOrder === false)
                {
                    localStorage.setItem("orderDeliveryTimeSelectedByUser" , false)
                }
                else
                {
                    localStorage.setItem("orderDeliveryTimeSelectedByUser" , true)
                }
            }
        })
    }


    handleChange(event){
        let fields = this.state.fields
        let target = event.target
        fields[target.name] = target.value
        let errors = this.state.errors
        errors[target.name] = undefined
        this.setState({errors: errors , fields:fields})
        //console.log(target.name , target.value.length)
        //console.log(target.name === "search" && target.value.length > 3)
        if (target.name === "search" && target.value.length >= 3)
        {
            this.searchSubmitHandler()
        }
    }
    searchSubmitHandler()
    {
        //console.log(this.state.branchSlug , this.state.fields.search)
        //console.log(11111)
        axios.get(vars.Url +'api/v3/product/search/' + this.state.branchSlug , {
            params : {
                "api_token" : localStorage.getItem('api_token') ,
                "with-category" : 0 ,
                "with-product" : 1 ,
                "search" : this.state.fields.search ,
                "page" : this.state.searchPage
            }

        }).then(response => {
            let data = response.data.data
            //console.log(0 ,data.products)
            //this.props.receiveProducts(data.products)
            this.setState({
                searchRequestLoading : false ,
                searchProducts : data.products ,
                searchHasMore : data.hasMore ,
                //searchPage : this.state.searchPage + 1
            })
        })
            .catch(error => {
                // console.log(error)
            })
    }
    searchShowHandler(){
        this.setState({
            searchShowModal : !this.state.searchShowModal
        })
    }

    needPreOrder(){
        //console.log(555555)
        this.setState({
            needPreOrderShowModal : !this.state.needPreOrderShowModal
        })
    }


    preOrderShowHandler(){
        this.setState({
            needPreOrderShowModal : false ,
            preOrderShowModal : !this.state.preOrderShowModal
        })




        setTimeout(
            function() {

                let dateSlier = new Swiper('#date-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 10,

                })
                dateSlier.update()

                let timeSlier = new Swiper('#time-slider', {
                    slidesPerView: 'auto',
                    spaceBetween: 10,

                })
                timeSlier.update()
            }
                .bind(this),
            100
        )



    }

    childLoadMoreHandler() {
        if (this.state.productSlier !== null)
        {
            this.state.productSlier.update()
        }
    }

    componentDidMount(){

        /*if(Object.keys(this.props.products).length !== 0)
            return true;*/

        /* localStorage.removeItem("orderDeliveryDateTitle")
         localStorage.removeItem("orderDeliveryDateValue")
         localStorage.removeItem( "orderDeliveryDateIsToday")

         localStorage.removeItem( "orderDeliveryTimeTime")
         localStorage.removeItem( "orderDeliveryTimeTitle")
         localStorage.removeItem( "orderDeliveryTimeKey")
         localStorage.setItem( "orderDeliveryTimeSelectedByUser" , false)
         localStorage.removeItem("description")*/



        const { params } = this.props.match;
        /*if (params.category !== undefined)
        {
            this.setState({
                currentCategory : params.category,
            })
        }*/
        let branchSlug = ""
        if (params.branch !== undefined)
        {
            this.setState({
                branchSlug : params.branch,
            })
            branchSlug = params.branch
            localStorage.setItem("branchSlug" , branchSlug)
        }


        //console.log(2222)
        axios.post(vars.Url +'api/v4/order/check/' + branchSlug , {
            params : {
                "api_token" : localStorage.getItem('api_token') ,
            }

        } )
            .then(response => {
                let data = response.data.data
                //console.log(data)
                this.setState({
                    //deliveryAvailableTimes : data.cart.deliveryAvailableTimes ,
                    preOrderDeliveryDates : data.cart.preOrderDeliveryDates ,
                    deliveryAvailableTimes : data.cart.preOrderDeliveryDates[0].timing
                })

                if(this.state.deliveryAvailableTimes === [])
                {
                    this.setState({
                        deliveryAvailableTimes : data.cart.preOrderDeliveryDates[0].timing
                    })
                }


                data.cart.preOrderDeliveryDates.map((preOrderDeliveryDate , index) => {
                    if (preOrderDeliveryDate.isToday === true && localStorage.getItem( "orderDeliveryDateTitle" ) === null)
                    {
                        this.setState({
                            orderDeliveryDateTitle : "امروز" ,
                            orderDeliveryDateValue : preOrderDeliveryDate.value
                        })

                        localStorage.setItem( "orderDeliveryDateTitle" ,  "امروز")
                        localStorage.setItem( "orderDeliveryDateValue" ,  preOrderDeliveryDate.value )
                        localStorage.setItem( "orderDeliveryDateIsToday" ,  true )

                    }
                })



                data.cart.deliveryAvailableTimes.map((deliveryAvailableTime , index) => {

                    if (deliveryAvailableTime.available === true && localStorage.getItem( "orderDeliveryTimeTime" ) === null )
                    {
                        this.setState({
                            orderDeliveryTimeTime : deliveryAvailableTime.time
                        })

                        localStorage.setItem( "orderDeliveryTimePreview" ,  deliveryAvailableTime.preview)
                        localStorage.setItem( "orderDeliveryTimeTime" ,  deliveryAvailableTime.time)
                        localStorage.setItem( "orderDeliveryTimeTitle" ,  deliveryAvailableTime.title)
                        localStorage.setItem( "orderDeliveryTimeKey" ,  deliveryAvailableTime.key)


                    }
                })

                let showPreOrderModal = true;
                data.cart.preOrderDeliveryDates.map((preOrderDeliveryDate , index) => {

                    //console.log(preOrderDeliveryDate)
                    if (preOrderDeliveryDate.isToday === true)
                    {
                        preOrderDeliveryDate.timing.map((todayTime, index) => {
                            if (todayTime.available === true)
                            {
                                showPreOrderModal = false
                            }
                        })
                    }
                })

                if (showPreOrderModal && !this.state.showPreorderAlertForFirstTime)
                {
                    this.needPreOrder()
                }


            })
            .catch(error => {
                // console.log(error)
            })


        //console.log(3333)
        axios.get(vars.Url +'api/v3/product/' + branchSlug , {
            params : {
                "api_token" : localStorage.getItem('api_token') ,
                "with-category" : 1 ,
                "with-product" : 0 ,
                "category" : null
            }

        } )
            .then(response => {
                let data = response.data.data
                //console.log(data)
                localStorage.setItem("branchOnlinePay" , data.branch.onlinePay)

                data.categories.map((category , index) => {
                    if (this.state.currentCategory === category.slug)
                    {
                        this.setState({
                            currentCategory : category.title ,
                            currentCategorySlideIndex : index
                        })
                        return false
                    }
                })
                if (this.state.currentCategory === null)
                {
                    this.setState({
                        currentCategory : data.categories[0].title ,
                        currentCategorySlideIndex : 0
                    })
                }

                this.setState({
                    requestLoading : false ,
                    categories : data.categories ,
                    currentCategory : data.categories[0].title ,
                    branch : data.branch
                })

                if (this.state.branch.length === 0){

                    localStorage.setItem("currentTimeDescription" , data.branch.delivery.currentTimeDescription)
                    localStorage.setItem("branchAddress" , data.branch.contactInfo.address)
                    localStorage.setItem("branchPhone" , data.branch.contactInfo.phone)

                    this.setState({
                        branch : data.branch
                    })
                }

                /*console.log(333333333)
                this.needPreOrder.bind(this)
                this.setState({
                    needPreOrderShowModal : !this.state.needPreOrderShowModal
                })*/
                //this.needPreOrder()

            })
            .catch(error => {
                // console.log(error)
            })


        this.cartHandler()


    }


    componentDidUpdate(prevProps, prevState){


        let categorySlier = null;
        let productSlier = null;


        if (prevState.categories !== this.state.categories )
        {

            categorySlier = new Swiper('#category-slider', {
                slidesPerView: 'auto',
                spaceBetween: 10,

            });

            productSlier = new Swiper('#product-slider', {
                slidesPerView: 1,
                spaceBetween: 10,
                autoHeight: true ,
                calculateHeight:true,
                thumbs: {
                    swiper: categorySlier
                } ,
                on: {
                    slideChange : () => {
                        let index_currentSlide = productSlier.realIndex
                        let currentSlide = productSlier.slides[index_currentSlide]
                        this.setState({
                            currentCategory : currentSlide.getAttribute("data-title"),
                        })
                    }
                }

            });
            if (this.state.currentCategorySlideIndex !== null)
            {
                productSlier.slideTo(this.state.currentCategorySlideIndex)
            }

            this.setState({
                categorySlier : categorySlier ,
                productSlier : productSlier ,
            })
        }
        if (prevProps.cart !== this.props.cart) {
            this.cartHandler()
        }
    }



    render(){
        //console.log(1,this.state.searchProducts)
        return(

            <div id="main-custom-1" className="text-decoration-none">


                <header id="header-2" className="text-decoration-none">
                    <div className="container p-0">
                        <div className="row no-gutters justify-content-center">
                            <div className="col-lg-6">

                                <div className="items-container">

                                    <div className="top-items">
                                        <div className="row justify-content-between">

                                            <div className="col-auto">
                                                <Link to="/">
                                                    <span>
                                                        <img src={backIcon} alt="back" className="item-icon" />
                                                    </span>
                                                </Link>
                                            </div>

                                            <div className="col-auto">
                                                {/*<Link to="/search">
                                                    <div>
                                                        <img src={searchIcon} alt="search" className="item-icon" />
                                                    </div>
                                                </Link>*/}
                                                <div>
                                                    <div onClick={this.searchShowHandler.bind(this)}>
                                                        <img src={searchIcon} alt="search" className="item-icon" />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="bottom-items mt-5">
                                        <div className="row no-gutters justify-content-between align-items-end">
                                            <div className="col-auto">
                                                <div className="title">
                                                    {this.state.currentCategory}
                                                </div>
                                            </div>
                                            <div className="col-auto text-left">
                                                {/*<div>
                                                    <div className="item mb-2">
                                                    <span className="title">
                                                        تحویل رایگان در محدوده
                                                    </span>
                                                        <img src={deliveryIcon} alt="delivery" className="item-icon" />
                                                    </div>
                                                </div>*/}
                                                <div>
                                                    <div className="item-2" onClick={this.preOrderShowHandler.bind(this)}>
                                                        <img src={arrowBottomIcon} alt="timer" className="item-icon-right" />
                                                        <span className="title">
                                                        ارسال:
                                                            {
                                                                this.state.orderDeliveryDateTitle !== null ?
                                                                    (
                                                                        this.state.orderDeliveryDateTitle
                                                                    )
                                                                    :
                                                                    ("-")
                                                            }
                                                    </span>
                                                        <img src={timerIcon} alt="timer" className="item-icon" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>



                                </div>



                            </div>
                        </div>
                    </div>
                </header>






                <div className="container p-0">
                    <div className="row no-gutters justify-content-center">
                        <div className="col-lg-6">

                            <div className="items-container">

                                {
                                    this.state.requestLoading === true ?
                                        (
                                            <div>
                                                <Loader />
                                            </div>
                                        ) :
                                        (
                                            <div>

                                                <div className="swiper-container" id="category-slider" dir="rtl">
                                                    <div className="swiper-wrapper">
                                                        {this.state.categories.map((object , index) =>
                                                            <div className="swiper-slide" key={index} >
                                                                <div className="card-custom-3">
                                                                    {object.title}
                                                                </div>
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>



                                                <div className="swiper-container" id="product-slider" dir="rtl" >
                                                    <div className="swiper-wrapper">
                                                        {this.state.categories.map((object , index) =>
                                                            <div className="swiper-slide" key={index}  data-title={object.title}>
                                                                <ProductSection
                                                                    branchSlug={this.state.branchSlug}
                                                                    category={object}
                                                                    currentCategory={this.state.currentCategory}
                                                                    childLoadMoreHandler={this.childLoadMoreHandler.bind(this)}
                                                                    cartHandler={this.cartHandler.bind(this)}
                                                                    currentTime={this.state.orderDeliveryTimeTime}
                                                                    needPreOrder={this.needPreOrder.bind(this)}
                                                                />
                                                            </div>
                                                        )}

                                                    </div>
                                                </div>


                                            </div>
                                        )
                                }

                            </div>

                        </div>
                    </div>
                </div>

                <Modal show={this.state.preOrderShowModal} onHide={() => this.setState({preOrderShowModal:false})} className="bottom-sheet modal-custom-1" centered>

                    <Modal.Body>
                        <div className="title">
                            <img src={timerIcon} alt="timer" className="item-icon" />
                            پیش سفارش برای...
                        </div>
                        <div className="mt-3">
                            <div className="swiper-container" id="date-slider" dir="rtl" >
                                <div className="swiper-wrapper">
                                    {this.state.preOrderDeliveryDates.map((object , index) =>
                                        <div className="swiper-slide w-auto" key={index} >
                                            <div onClick={this.orderDeliveryDateHandler.bind(this)} data-value={object.value} className={"card-custom-5 " + (object.value === this.state.orderDeliveryDateValue ?  "active " : "")}>

                                                {
                                                    object.isToday === true ?
                                                        (
                                                            `امروز`
                                                        )
                                                        :
                                                        (
                                                            object.title
                                                        )
                                                }
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>


                        <div className="title mt-5">
                            بازه ساعت تحویل
                        </div>
                        <div className="mt-3">
                            <div className="swiper-container" id="time-slider" dir="rtl" >
                                <div className="swiper-wrapper">
                                    {this.state.deliveryAvailableTimes.map((object , index) =>
                                        object.preview === true ? (
                                            <div className="swiper-slide w-auto" key={index} >
                                                <div onClick={this.orderDeliveryTimeHandler.bind(this)} data-time={object.time} className={"card-custom-5 " + (object.time === this.state.orderDeliveryTimeTime ?  "active " : " ") + (object.available !== true && this.state.orderInPreOrder === false ?  "disable " : " ")}>

                                                    {
                                                        object.current === true && this.state.orderInPreOrder === false ?
                                                            (
                                                                `پس از آماده‌سازی`
                                                            )
                                                            :
                                                            (
                                                                object.title
                                                            )
                                                    }
                                                </div>
                                            </div>
                                        ) : (``)

                                    )}
                                </div>
                            </div>
                        </div>

                        <div className="mt-5 text-center">
                            <div className="row justify-content-center">
                                <div className="col-6">
                                    <button className="btn btn-block btn-custom-2" onClick={() => this.setState({preOrderShowModal:false})}>
                                        تایید
                                    </button>
                                </div>

                            </div>

                        </div>

                    </Modal.Body>
                </Modal>



                <Modal show={this.state.needPreOrderShowModal} onHide={() => this.setState({needPreOrderShowModal:false})} className="bottom-sheet modal-custom-1" centered>

                    <Modal.Body>
                        <div className="title">
                            <img src={timerIcon} alt="timer" className="item-icon" />
                            امکان پیش سفارش
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                فروشگاه هم اکنون امکان ارسال سفارش ندارد
                                <br />
                                می توانید الان سفارش دهید و در نزدیکترین زمان ممکن تحویل بگیرید.
                                <br />
                                رسیدگی به سفارشات از ساعت 9:00 الی 19:00 هر روز
                            </div>
                        </div>



                        <div className="mt-5 text-center">
                            <div className="row no-gutters">
                                <div className="col-6 pl-2">
                                    <button className="btn btn-block btn-custom-2" onClick={this.preOrderShowHandler.bind(this)}>
                                        پیش سفارش
                                    </button>
                                </div>
                                <div className="col-6 pr-2">
                                    <button className="btn btn-block btn-custom-3" onClick={() => this.setState({needPreOrderShowModal : false})}>
                                        مشاهده محصولات
                                    </button>
                                </div>
                            </div>

                        </div>

                    </Modal.Body>
                </Modal>



                <Modal show={this.state.searchShowModal} onHide={() => this.setState({searchShowModal:false})} className="bottom-sheet modal-custom-1" centered
                >

                    <Modal.Body className="p-0 p-lg-3">
                        <div className="title">
                            <img src={searchIcon} alt="search" className="item-icon" />
                            جستجو
                        </div>
                        <div className="mt-3">
                            <div className="content-custom-1">
                                <div className="form-group form-group-custom-1">
                                    <input
                                        type="text"
                                        className="form-control form-control-custom-1 pr-3 pl-3"
                                        name="search"
                                        onChange={this.handleChange.bind(this)}
                                        placeholder="نام محصول ..."
                                        value={this.state.fields.search}  />
                                    {/*<img src={searchIcon} alt="smart-search" className="item-icon" />*/}
                                </div>
                            </div>
                        </div>



                        <div className="mt-5 text-center">
                            <div className="row no-gutters">
                                <div className="col-12 pl-2">

                                    <div style={{ overflowY:"scroll",maxHeight:"200px",bottom:"0"}}>

                                        <div className="product-card">
                                            {this.state.searchProducts.map((object , index) =>

                                                <ProductCard
                                                    key={index}
                                                    product={object}
                                                    cartHandler={this.cartHandler.bind(this)}
                                                    currentTime={this.state.orderDeliveryTimeTime}
                                                    needPreOrder={this.needPreOrder.bind(this)}
                                                />
                                            )}

                                            {this.state.searchRequestLoading === true ? (
                                                <Loader />
                                            ) : (
                                                ``
                                            )}
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                    </Modal.Body>
                </Modal>


                <Link to="/cart" className={"btn-custom-4 " + (this.state.cartLinkShow === true ? "show" : "")} id="shopping-bag">
                    <img src={shoppingBagIcon} alt="shopping-bag" className="item-icon" />
                    <span className="title">
                        سبد خرید
                    </span>
                    <span className="price">
                        <NumberFormat value={this.state.cartSumPrice} displayType={'text'} thousandSeparator={true} className="mr-2" />
                        <span className="mr-2">ت</span>
                    </span>
                </Link>

                <Footer page="product"/>
            </div>
        )
    }
}


const mapDispatchToProps = dispatch => ({

    removeFromUserCart : productId => dispatch(removeFromUserCart(productId)) ,
    removeFromCart : productId => dispatch(removeFromCart(productId)) ,
})

const mapStateToProps = state => {
    return {
        cart : state.cart ,
        products : state.products ,
    }
}

export default connect( mapStateToProps , mapDispatchToProps)(ProductV4);